import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { templatesApi } from '../api/templates';
import { getErrorMessage } from '../api/client';
import Spinner from '../components/ui/Spinner';
import Alert from '../components/ui/Alert';
import TemplateCard from '../components/TemplateCard';


export default function Templates() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [category, setCategory] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await templatesApi.list(category || undefined);
        setTemplates(data);
      } catch (err) {
        setError(getErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [category]);

  const categories = ['', 'Matrimonios', 'Cumpleaños', 'Baby Shower', 'Bautizos', 'Graduaciones'];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-extrabold">Elige una plantilla</h1>
        <p className="text-sm text-slate-500">Personaliza y publica tu invitación en minutos.</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {categories.map((c) => (
          <button
            key={c || 'all'}
            onClick={() => setCategory(c)}
            className={`px-4 py-2 rounded-full text-xs font-semibold transition ${
              category === c
                ? 'bg-brand-500 text-white'
                : 'bg-white border border-slate-300 text-slate-600 hover:bg-slate-100'
            }`}
          >
            {c || 'Todas'}
          </button>
        ))}
      </div>

      {error && <Alert type="error">{error}</Alert>}

      {loading ? (
        <div className="grid place-items-center py-20">
          <Spinner size="lg" className="text-brand-500" />
        </div>
      ) : templates.length === 0 ? (
        <div className="text-center py-20 text-slate-500">No hay plantillas en esta categoría.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {templates.map((tpl) => (
            <TemplateCard
              key={tpl.id}
              template={tpl}
              onSelect={() => navigate(`/events/new/${tpl.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
}